.columns {
  width: 100%;
  overflow-x: hidden;
}
